import React from 'react';
import styled from 'styled-components';

enum StaticFieldSize {
    Small = 1,
    Large = 2,
}

interface StaticFieldRequiredProps {
    size: StaticFieldSize;
    label: string;
}

interface StaticFieldOptionalProps {
    value?: string;
    className?: string;
    editable?: boolean;
}

interface StaticFieldProps extends StaticFieldRequiredProps, StaticFieldOptionalProps {}

const defaultProps: StaticFieldOptionalProps = {
    editable: false,
    value: '',
};

const Container = styled.div<{ size: StaticFieldSize; editable: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    box-sizing: border-box;
    min-height: 60px;
    padding: 0px 15px;
    border: 1px solid rgb(206, 212, 218);
    grid-column: ${props => `span ${props.size}`};
    cursor: ${props => (props.editable ? 'pointer' : 'default')};
`;

const Label = styled.span`
    color: ${props => props.theme.antd['text-color']};
    font-size: 0.7rem;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: captialize;
    text-align: center;
    align-items: center;
    line-height: 1.5;
`;

// changing editable type from bool to string fix the react warning message for non-boolean attribute
const Value = styled.span<{ editable: string }>`
    color: ${props => (props.editable === 'true' ? props.theme.antd['primary-color'] : props.theme.antd['text-color'])};
    font-size: 0.7rem;
    line-height: 1.2;
    text-overflow: ellipsis;
    vertical-align: baseline;
    min-height: 20px;
    overflow: hidden;
    text-align: center;

    @media (min-width: 480px) {
        font-size: 1rem;
    }
`;

const StaticField = (props: StaticFieldProps) => {
    const { className, label, value, size, editable } = props;

    return (
        <Container className={className} editable={editable} size={size}>
            <Label>{label}</Label>
            <Value editable={`${editable}`}>{value}</Value>
        </Container>
    );
};

StaticField.defaultProps = defaultProps;

export default StaticField;
